import React, {useContext, useState} from 'react';
import {AuthContext} from 'contexts/auth/auth.provider';
import {closeModal} from "@redq/reuse-modal";
import {NotificationManager} from 'react-notifications';
import {useFormik} from "formik";
import * as Yup from 'yup';
import {SignupForm} from "pages/signup";


export default function SignOutModal() {
    const {authDispatch, signUp, federatedSignIn, loading} = useContext<any>(AuthContext);
    const [done, setDone] = useState(false);


    const toggleSignInForm = () => {
        authDispatch({
            type: 'SIGNIN',
        });
    };

    function onFederated(provider) {
        federatedSignIn({
            provider,
            customState: {
                a: 1
            }
        }).then(() => {

        })
            .catch(e => console.log(e))
    }


    const {getFieldProps, handleSubmit, errors, touched, isValid,} = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            firstName: '',
            lastName: '',
            password: '',
        },

        onSubmit: onSignupClick,
        validationSchema: Yup.object().shape({
            firstName: Yup.string()
                .required('First name is required'),
            lastName: Yup.string()
                .required('Last name is required'),
            email: Yup.string()
                .email('Invalid email')
                .required('Email is required'),
            password: Yup.string()
                .min(8, 'Password must be at least 8 characters')
                .required('Password is required'),
        })
    });


    function onSignupClick(values) {
        signUp(values)
            .then((user) => {
                NotificationManager.success(`Welcome, please check your email`, 'Thank you!', 5000, true);
            }).catch(e => {
            NotificationManager.error(e.message, 'Login Error', 5000, true);
        })
            .finally(() => {
                closeModal();
            });
    }

    return (
        <>
            <SignupForm/>
        </>
    );
}
